import { createFileRoute } from '@tanstack/react-router'
import { QrTool } from '~/features/ai-studio/components'

export const Route = createFileRoute('/dashboard/ai-studio/qr')({
  component: QrTool,
})
